import { Button } from '@/components/button/Button'
import type { ReactNode } from 'react'

export default function TableProgressPanel({ label, children, onViewErrors }: { label: string; children: ReactNode; onViewErrors?: () => void }) {
  return (
    <section aria-label={label} className="min-h-11 w-full min-w-0 space-y-2 rounded-md border border-brand-neutral-200 bg-white px-4 py-2 text-sm">
      {children}
      {onViewErrors && (
        <Button size="xs" variant="plain" onClick={onViewErrors}>
          View errors
        </Button>
      )}
    </section>
  )
}
